import { memo } from "react";
import Box from "@mui/material/Box";
import { useDroppable } from "@dnd-kit/core";
import {
  SortableContext,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import Typography from "@mui/material/Typography";
import { Project } from "../types";
import SortableProjectItem from "./SortableProjectItem";
import ProjectItem from "./ProjectItem";
import styles from "./styles.module.scss";
import Badge from "@mui/material/Badge/Badge";

type BoardSectionProps = {
  id: string;
  title: string;
  projects: Project[];
};

const BoardSection = memo(({ id, title, projects }: BoardSectionProps) => {
  const { setNodeRef } = useDroppable({
    id,
  });

  return (
    <Box className={styles.divBox} sx={{ padding: 2 }}>
      <div className={styles.title}>
        <Typography variant="h6" sx={{ mb: 2 }}>
          <label>{title}</label>
        </Typography>
        <Badge badgeContent={projects.length} color="primary" />
      </div>
      <SortableContext
        id={id}
        items={projects}
        strategy={verticalListSortingStrategy}
      >
        <div ref={setNodeRef}>
          {projects.map((project) => (
            <Box key={project.id} sx={{ mb: 2 }}>
              <SortableProjectItem id={project.id}>
                <ProjectItem project={project} />
              </SortableProjectItem>
            </Box>
          ))}
        </div>
      </SortableContext>
    </Box>
  );
});

export default BoardSection;
